import React, { useState, useRef, useEffect } from "react";

export default function DropdownButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Select an option");
  const dropdownRef = useRef(null);

  const items = ["Profile", "Settings", "Logout"];

  const handleSelect = (item) => {
    setSelected(item);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      ref={dropdownRef}
      style={{
        position: "relative",
        display: "inline-block",
        fontFamily: "sans-serif",
      }}
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: "10px 16px",
          fontSize: "16px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          cursor: "pointer",
          backgroundColor: "#f8f9fa",
        }}
      >
        {selected} ▾
      </button>

      {isOpen && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "8px",
            listStyle: "none",
            padding: 0,
            margin: "8px 0 0 0",
            width: "100%",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            zIndex: 10,
          }}
        >
          {items.map((item) => (
            <li
              key={item}
              onClick={() => handleSelect(item)}
              style={{
                padding: "10px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
              }}
              onMouseEnter={(e) =>
                (e.target.style.backgroundColor = "#f1f1f1")
              }
              onMouseLeave={(e) =>
                (e.target.style.backgroundColor = "#fff")
              }
            >
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
